// extracted by mini-css-extract-plugin
export default {"list":"_-_-record-it-components-src-dropdown-DropdownList-__list"};